import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import jobsData from "../data/jobsData";
import Navbar from "./Navbar";
import Footer from "./Footer";

const JobDetailsPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const job = jobsData.find((j) => j.id === jobId);

  if (!job) {
    return (
      <div className="py-24 text-center">
        <h2 className="text-2xl font-bold">Job Not Found</h2>
      </div>
    );
  }

  return (
    <div className="bg-gray-50">
      <Navbar />
    <section className="py-24 px-4 bg-gray-50">
      <div className="max-w-3xl mx-auto bg-white p-10 rounded-2xl shadow-md">

        <button
          onClick={() => navigate(-1)}
          className="text-orange-500 mb-6 font-semibold"
        >
          ← Back to Jobs
        </button>

        <h1 className="text-3xl font-bold mb-4">{job.title}</h1>

        <p className="text-gray-500 mb-2">
          {job.location} • {job.type}
        </p>
        <p className="text-gray-500 mb-2">
          Salary: {job.salary}
        </p>

        <p className="text-gray-500 mb-6">
          Experience: {job.experience}
        </p>

        <div className="flex flex-wrap gap-2 mb-6">
          {job.skills.map((skill, index) => (
            <span
              key={index}
              className="px-3 py-1 bg-orange-100 text-orange-600 rounded-full text-sm"
            >
              {skill}
            </span>
          ))}
        </div>

        <p className="text-gray-700 mb-6">
          {job.fullDescription}
        </p>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Responsibilities</h3>
          <ul className="list-disc list-inside text-gray-600">
            {job.responsibilities.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-2">Requirements</h3>
          <ul className="list-disc list-inside text-gray-600">
            {job.requirements.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div >
        <div>
        <h3 className="text-xl font-semibold mb-2">How to Apply</h3>
        <p className="text-gray-600">
          To apply for this job, please send your resume to <a href="mailto:info@infuber.com" className="text-orange-500">info@infuber.com</a>
        </p>
        <p className="text-gray-600">
          We will review your application and get back to you soon.
        </p>
        <p className="text-gray-600">
          Thank you for your interest in working with us.
        </p>
        </div>
      </div>
    </section>
    <Footer />
    </div>
  );
};

export default JobDetailsPage;
